/**
 * MetaKeywordQualifier
 * The qualifier list sends each meta tag name as an array entry (EvaluatedObject from config).
 * For each name, reads all matching <meta name="..."> tags and returns one
 * { key: metaName, value: content } entry per tag.
 *
 * The API's CheckMetaKeywordCondition reads ALL "metakeyword" items from Request.Request
 * and checks each Value against rule.Value — so multiple items work correctly.
 * Mirrors ConneXt v2 MetaKeyword.getMetaTags(name).
 */
export class MetaKeywordQualifier {
    constructor() {
        this.key = "MetaKeyword";
    }
    process(config) {
        var _a;
        const metaNames = Array.isArray(config) ? config : [];
        const results = [];
        for (const name of metaNames) {
            if (!name)
                continue;
            const tags = this.getMetaTags(name);
            for (const tag of tags) {
                const content = (_a = tag.content) === null || _a === void 0 ? void 0 : _a.trim();
                if (content) {
                    results.push({ key: name, value: content });
                }
            }
        }
        return results;
    }
    getMetaTags(name) {
        try {
            return Array.from(document.querySelectorAll(`meta[name="${name}"]`));
        }
        catch (_a) {
            return [];
        }
    }
}
